module.exports = __webpack_public_path__ + "img/somaliland.2b344979.svg";